// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
import { createNodeHttpClient } from "./nodeHttpClient.js";
/**
 * Create the correct HttpClient for the current environment.
 */
export function createDefaultHttpClient() {
    return createNodeHttpClient();
}
//# sourceMappingURL=defaultHttpClient.js.map